import { Component, ViewEncapsulation, Input } from '@angular/core';
import { MobileCheckServiceService } from '../../services/mobile-check-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeroComponent {
  @Input()
  public slides: Array<object>;

  constructor(
    private mobileCheck: MobileCheckServiceService,
    private router: Router
  ) {}

  get isMobileDevice(): boolean {
    return this.mobileCheck.mobileDevice;
  }

  showDetails(url: string) {
    if (!url) {
      return;
    }

    this.router.navigate([url]);
  }

  onClick() {}
}
